var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrintBarcode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 30,
    viewBox: "0 0 34 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.1818 13.1717H24.7273V14.8182H23.1818V13.1717Z",
    fill: "#414042"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 4.93939V29.6364H34V0H4.63636L0 4.93939ZM12.3621 4.93954V8.23242H21.6349V4.93954H12.3621ZM9.27273 9.87879L6.18182 13.1716V21.404H10.8182V18.1111H23.1818V21.404H27.8182V13.1716L24.7273 9.87879H9.27273ZM10.8182 24.697L13.9091 19.7576H20.0909L23.1818 24.697H10.8182Z",
    fill: "#414042"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrintBarcode);
export default __webpack_public_path__ + "static/media/PrintBarcode.81324ccc1b2801ed5ef962ee906beae8.svg";
export { ForwardRef as ReactComponent };